module.exports = __webpack_public_path__ + "static/media/subimg.fb876f46.jpg";